import { pbx_module_breadcrumbs } from './_module';

const index = pbx_module_breadcrumbs
  .extend('pbx.time-condition.index')
  .add('pbx.breadcrumb.time-condition.index', { name: 'pbx.time-condition.index' });

const create = index
  .extend('pbx.time-condition.create')
  .add('pbx.breadcrumb.time-condition.create', { name: 'pbx.time-condition.create' });

const edit = index
  .extend('pbx.time-condition.edit')
  .add('pbx.breadcrumb.time-condition.edit', { name: 'pbx.time-condition.edit' });

export const pbx_time_conditions_breadcrumbs = [index, create, edit];
